module.exports = __webpack_public_path__ + "static/media/vanskelig.9690d43e.m4a";